import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ''
};

export const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const firebaseGoogleProvider = new GoogleAuthProvider();
firebaseGoogleProvider.setCustomParameters({ prompt: 'select_account' });

export const initFirebaseAnalytics = async () => {
  try {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const isLocalHost = ['localhost', '127.0.0.1'].includes(host);
    if (isLocalHost) return null;
    if (typeof navigator !== 'undefined' && navigator.doNotTrack === '1') return null;
    if (!(await analyticsSupported())) return null;
    if (!firebaseConfig.measurementId) return null;
    return getAnalytics(firebaseApp);
  } catch (e) {
    return null;
  }
};

export default firebaseApp;
